function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Generated file, do not edit directly.
 */
import React from 'react';
import { Icon } from '@dna/icon';
export function IconCopy(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17 1H5c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H9c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H9V7h11v14z",
    "fill-rule": "evenodd"
  })));
}